module.exports = __webpack_public_path__ + "static/media/thank_you.9be4a010.png";